import * as React from 'react';
import { ComplexValue } from 'app/types-shared';
import { VisibleForFields } from 'app/components/visible-for-fields';
import { UserOccurencePanelProps, UserOccurencePanelState } from './types';
import { hasPersonOptionsValues, hasPersonOptionsCodes } from './selectors';
import { withRoleBasedAccess, RoleBasedAccessCustomStateProps } from '../role-based-access';
import { mapInvalidOptions } from '../shared';

type UserOccurencePanelComponentProps = UserOccurencePanelProps & RoleBasedAccessCustomStateProps<UserOccurencePanelState>;

class UserOccurencePanelComponent extends React.PureComponent<UserOccurencePanelComponentProps> {

  public componentDidMount() {
    this.buildInitalState();
  }

  public componentDidUpdate() {
    this.buildInitalState();
  }

  private buildInitalState = () => {

    const { customState, changeCustomState, initialValue } = this.props;

    if (customState || !initialValue) {
      return;
    }

    const selectedValues = initialValue.map(item => ({
      value: item.v,
      description: item.d
    }));

    changeCustomState({
      selectedValues,
      initialValues: selectedValues
    });
  };

  private onChange = (values: ComplexValue<number>[]) => {

    if (this.props.readOnly) {
      return;
    }

    const { formName, changeCustomState, customState, clearValidation } = this.props;

    clearValidation(formName);

    changeCustomState({
      ...(customState || {}),
      selectedValues: values
    });
  };

  public render() {
    const { customState: { selectedValues = [], initialValues = [] } = {}, translation, readOnly, unSelectAllValues,
      personOptionsCodes, formName, valueName, validation } = this.props;

    const hasValues = this.props.personOptionsCodes?.values?.length > 0 || hasPersonOptionsValues(selectedValues);

    const options = (personOptionsCodes?.values ?? []).map(item => { return { value: item.v, description: item.d } });

    const invalidOptions = mapInvalidOptions(validation && validation[formName], valueName);

    return <>
      {hasValues
        ? <div className="row expanders-in-equal-cols">
          <VisibleForFields
            options={options}
            valueItems={unSelectAllValues ? options : selectedValues}
            initialValueItems={initialValues}
            invalidOptions={invalidOptions}
            validation={validation && validation[formName]}
            onChange={this.onChange}
            readOnly={readOnly}
            onEmptyOptions={undefined}
          />
        </div>
        : <p className="no-content">{(!!readOnly || !hasPersonOptionsCodes(personOptionsCodes))
          ? translation.no_fields_available
          : null}</p>
      }
    </>;
  }
}

export const UserOccurencePanel = withRoleBasedAccess<UserOccurencePanelProps, UserOccurencePanelState>(UserOccurencePanelComponent);
